module.exports = __webpack_public_path__ + "static/media/profile.090a5aab.jpg";